import { FormattedMessage } from 'react-intl';

import { useModals } from 'context';

import { Button, Modal } from 'components';
import error from 'images/error.png';
import success from 'images/success.png';

import { FeedbackProps } from './types';

import * as S from './styles';

const Feedback: React.FC<FeedbackProps> = ({
  isOpen,
  modalKey,
  props,
  onClose,
}) => {
  const { closeModal } = useModals();

  if (!props) return null;

  const {
    title,
    message,
    status,
    action = () => closeModal(modalKey),
    actionLabel = 'FEEDBACK.ACTION.DEFAULT',
  } = props;

  const renderIcon = () => {
    if (status === 'error') {
      return <img data-testid="feedbackError" alt={status} src={error} />;
    }

    return <img data-testid="feedbackSuccess" alt={status} src={success} />;
  };

  return (
    <Modal
      isOpen={isOpen}
      onAfterClose={() => {
        if (onClose) onClose();
      }}
      closeModal={() => closeModal(modalKey)}
    >
      <S.Container data-testid="feedbackContainer">
        <S.Icon data-testid="feedbackIcon">{renderIcon()}</S.Icon>
        <S.Content data-testid="feedbackContent">
          <S.Text data-testid="feedbackMessage">
            <FormattedMessage id={title} />
          </S.Text>
          {message && <FormattedMessage id={message} />}
        </S.Content>
        <S.Footer>
          <Button data-testid="feedbackConfirm" onClick={action}>
            <FormattedMessage id={actionLabel} />
          </Button>
        </S.Footer>
      </S.Container>
    </Modal>
  );
};

export default Feedback;
